import { render, staticRenderFns } from "./ticketsComponent.vue?vue&type=template&id=3540b652"
import script from "./ticketsComponent.vue?vue&type=script&lang=js"
export * from "./ticketsComponent.vue?vue&type=script&lang=js"
import style0 from "./ticketsComponent.vue?vue&type=style&index=0&id=3540b652&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports